import dayjs from 'lib/helpers/dayjs';
import Actions from './Actions'

export default class FilterActions extends Actions{
    static get target(){
        return 'filters'
    }

    static reset(){
        this.set({
            patientCount: '',
            appointmentTypeID: '',
            startDate: dayjs().format(),
            availabilitiesReceived: [],
            selectedAdministratorID: ''
        })
    }
}


// WEBPACK FOOTER //
// ./actions/FilterActions.js